import { FC } from 'react';
import { WarningAlert } from 'components/Alerts';
import {
  CUSTOMER_SUPPORT_CALL_HOURS,
  CUSTOMER_SUPPORT_CALL_DAYS,
  CUSTOMER_SUPPORT_HOTLINE_AU,
  CUSTOMER_SUPPORT_HOTLINE_INTL,
} from 'config/constants';
import TelLink from 'components/TelLink';

const QantasPassNotification: FC = () => (
  <WarningAlert>
    <WarningAlert.Heading>
      This booking was paid with Qantas Passes or Credit. To make changes or cancel this booking, please contact us
    </WarningAlert.Heading>
    <WarningAlert.Body>
      Call <TelLink underline number={CUSTOMER_SUPPORT_HOTLINE_AU} color="greys.steel" /> or if you are outside of Australia, call{' '}
      <TelLink underline number={CUSTOMER_SUPPORT_HOTLINE_INTL} color="greys.steel" /> from {CUSTOMER_SUPPORT_CALL_HOURS} -{' '}
      {CUSTOMER_SUPPORT_CALL_DAYS}
    </WarningAlert.Body>
  </WarningAlert>
);

export default QantasPassNotification;
